import { DASHBOARD, DASHBOARD_MONTHLY_SALES } from "./types";


export const dashboardAction = (data, onSuccess, onError) => {
    return {
        type: DASHBOARD,
        data,
        onSuccess,
        onError,
    };
};

export const dashboardMontlySalesAction = (data, onSuccess, onError) => {
    return {
        type: DASHBOARD_MONTHLY_SALES,
        data,
        onSuccess,
        onError,
    };
};